/* eslint-disable camelcase */
import ConfidenceLevel from "../ConfidenceLevel";
import GoalType from "../GoalType";
import TeamMemberStatusType from "../TeamMemberStatusType";
import TeamRoleType from "../TeamRoleType";
import OneOnOneTeamRoleType from "../OneOnOneTeamRoleType";

export default {
	//
	// ConfidenceLevel enum
	//
	[ `ConfidenceLevel_${ ConfidenceLevel.HIGH }` ]: "HIGH",
	[ `ConfidenceLevel_${ ConfidenceLevel.MEDIUM }` ]: "MEDIUM",
	[ `ConfidenceLevel_${ ConfidenceLevel.LOW }` ]: "LOW",

	//
	// GoalType
	//
	[ `GoalType_${ GoalType.ACTIVE }Label` ]: "Active",
	[ `GoalType_${ GoalType.DRAFT }Label` ]: "Draft",
	[ `GoalType_${ GoalType.ARCHIVED }Label` ]: "Archived",

	//
	// TeamMemberStatus (enum)
	//
	[ `TeamMemberStatusType_${ TeamMemberStatusType.ACTIVE }` ]: "Active",
	[ `TeamMemberStatusType_${ TeamMemberStatusType.INVITED }` ]: "Invited",
	[ `TeamMemberStatusType_${ TeamMemberStatusType.DEFERRED }` ]: "Deferred",

	//
	// TeamRoleType
	//
	[ `TeamRoleType_${ TeamRoleType.LEAD }` ]: "Lead",
	[ `TeamRoleType_${ TeamRoleType.MEMBER }` ]: "Member",
	[ `TeamRoleType_${ TeamRoleType.MANAGER }` ]: "Manager",
	[ `TeamRoleType_${ TeamRoleType.REPORT }` ]: "Report",
	[ `TeamRoleType_${ TeamRoleType.PEER }` ]: "Peer",

	//
	// OneOnOneTeamRoleType
	//
	[ `OneOnOneTeamRoleType_${ OneOnOneTeamRoleType.MANAGER }` ]: "Manager",
	[ `OneOnOneTeamRoleType_${ OneOnOneTeamRoleType.REPORT }` ]: "Report",
	[ `OneOnOneTeamRoleType_${ OneOnOneTeamRoleType.PEER }` ]: "Peer",
};
